export default __webpack_public_path__ + "static/media/Icon_Agent_Twist_1024.94ff58bc.jpg";